var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.customFoodItemsByPet),function(ref,index){
var petItems = ref.items;
var pet = ref.pet;
return _c('span',{key:pet.id},[_vm._t("default",function(){return [_c('MenuItem',{attrs:{"items":petItems,"pet":pet,"promo-code":_vm.promoCode,"is-loading":_vm.isLoading},on:{"modify":function($event){return _vm.$emit('modify', index)}}})]},{"petItems":petItems,"pet":pet,"index":index}),(index !== _vm.customFoodItemsByPet.length - 1)?_c('Divider'):_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }